import React, { useState } from "react"
import { IconButton, Typography, Divider, Box } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import { CustomButton } from "../GlobalComponents/CommonComponents"
import "./index.css"
import BasicModal from "../GlobalComponents/BasicModal"
import { getBaseStorageUrl } from "../../utils/Helpers"

const FileUpload = (props) => {
  const {
    formData,
    handleChange,
    options,
    activeModal,
    setActiveModal,
    onCloseModal,
    setSelectedDeleteFiles,
    uploadedFiles,
    newFiles,
    isUploading,
    handleFileChange,
    handleFileDelete,
    handleFileUpload,
    handleUploadButtonClick
  } = props.data

  console.log("propssss formData", formData)

  let [selectedFile, setSelectedFile] = useState({})

  let modalData = {}
  if (activeModal === "UploadedImage") {
    modalData = {
      onClose: onCloseModal,
      title: selectedFile?.name,
      showSecondButton: false,
      show: true,
      modalStyles: {
        width: "60%",
        height: "90%",
        maxWidth: "900px",
        maxHeight: "600px",
      },
      modalStyleClassName: "file-upload-modal",
      showFooter: false,
    }
  }

  const onClickFile = (file) => {
    setActiveModal("UploadedImage")
    setSelectedFile(file)
  }

  console.log("filessss", newFiles)
  const allFiles = [...uploadedFiles, ...newFiles]
  return (
    <Box className="center-container" sx={{ flexDirection: "column" }}>
      <input
        type="file"
        id="file-upload"
        multiple
        accept="image/*,.pdf"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      <div>
        <label htmlFor="file-upload">
          <CustomButton component="span" text="Choose Files" />
        </label>
        <CustomButton
          sx={{ marginLeft: "30px", cursor: isUploading ? "default" : "pointer" }}
          component="span"
          text={`${isUploading ? "Uploading" : "Upload"}`}
          onClick={handleUploadButtonClick}
          disabled={newFiles.length === 0}
        />
      </div>

      {allFiles.length > 0 && (
        <ul className="items-ul-container">
          {allFiles?.map((file, index) => (
            <>
              <li
                key={file.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ width: "100%", cursor: "pointer" }}
                  onClick={() => onClickFile(file)}
                  className="active-link"
                >
                  {file.name}
                </Typography>
                <IconButton
                  title="Delete"
                  edge="end"
                  color="secondary"
                  onClick={() => handleFileDelete(file.id, file?.isNew)}
                >
                  <DeleteIcon />
                </IconButton>
              </li>
              <Divider />
            </>
          ))}
        </ul>
      )}

      {modalData.show && (
        <FileModal
          url={selectedFile.url}
          fileType={selectedFile.fileType}
          modalData={modalData}
        />
      )}
    </Box>
  )
}

export function FileModal(props) {
  let { url, fileType, modalData, bodyStyles = {} } = props
  if (!(url?.startsWith("http://") || url?.startsWith("https://"))) {
    url = `${getBaseStorageUrl()}/${url}`
  }
  return <BasicModal {...modalData}>

    <div className="modal-files-container" style={bodyStyles}>
      {fileType === "image" ? (
        <img
          src={url}
          className="modal-image" // Use the CSS class for images
        />
      ) : fileType === "pdf" ? (
        <embed
          src={url}
          type="application/pdf"
          className="modal-pdf" // Use the CSS class for PDFs
        />
      ) : null}
    </div>
  </BasicModal>
}

export default FileUpload
